// ─────────────────────────────────────────────────────
// SXT Portal — Login / Register Page
// ─────────────────────────────────────────────────────
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../services/api";

export function LoginPage() {
  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = isRegister
        ? await api.register(email, username, password)
        : await api.login(email, password);

      localStorage.setItem("sxt_token", data.access_token);
      localStorage.setItem("sxt_refresh_token", data.refresh_token);
      localStorage.setItem("sxt_user_id", data.user_id);
      navigate("/dashboard");
    } catch (err: unknown) {
      const msg =
        (err as { response?: { data?: { detail?: string } } })?.response?.data
          ?.detail || "Authentication failed";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-sxt-bg">
      <div className="w-full max-w-md rounded-2xl bg-sxt-surface p-8 shadow-xl">
        {/* Logo */}
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-white">
            SXT<span className="text-sxt-primary"> Portal</span>
          </h1>
          <p className="mt-2 text-sm text-sxt-muted">
            {isRegister ? "Create your account" : "Sign in to your style dashboard"}
          </p>
        </div>

        {error && (
          <div className="mb-4 rounded-lg bg-red-500/10 p-3 text-sm text-red-400">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm text-sxt-muted">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-sxt-muted outline-none focus:border-sxt-primary"
              placeholder="you@email.com"
            />
          </div>

          {isRegister && (
            <div>
              <label className="mb-1 block text-sm text-sxt-muted">Username</label>
              <input
                type="text"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-sxt-muted outline-none focus:border-sxt-primary"
                placeholder="sxt_user"
              />
            </div>
          )}

          <div>
            <label className="mb-1 block text-sm text-sxt-muted">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-sxt-muted outline-none focus:border-sxt-primary"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-sxt-primary py-3 font-semibold text-white transition hover:opacity-90 disabled:opacity-50"
          >
            {loading ? "..." : isRegister ? "Create Account" : "Sign In"}
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-sxt-muted">
          {isRegister ? "Already have an account?" : "Don't have an account?"}{" "}
          <button
            onClick={() => {
              setIsRegister(!isRegister);
              setError("");
            }}
            className="text-sxt-primary hover:underline"
          >
            {isRegister ? "Sign in" : "Register"}
          </button>
        </p>
      </div>
    </div>
  );
}
